(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('sticky-header')) {
    class AriistonHeader extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section') || this.parentElement;
        this.drawer = this.querySelector('[data-ah-drawer]');
        this.search = this.querySelector('[data-ah-search]');
        this.sticky = this.dataset.sticky || 'none';
        this.transparent = this.dataset.transparent === 'true';
        this.threshold = parseInt(this.dataset.threshold || '50', 10);
        this.clickMode = this.dataset.trigger === 'click';
        this.lastY = window.scrollY;
        this.open = null;
        this.hoverNone = window.matchMedia('(hover: none)');
        this.desktopMq = window.matchMedia('(min-width: 990px)');

        this._onScroll = this.onScroll.bind(this);
        this._onKey = this.onKey.bind(this);
        this._onClick = this.onClick.bind(this);
        this._onDocClick = this.onDocClick.bind(this);
        this._setHeight = this.setHeight.bind(this);
        this._onMq = (e) => { if (e.matches && this.open === 'drawer') this.closeDrawer(false); };
        this._onPrevent = () => {
          this.preventReveal = true;
          clearTimeout(this.prTimer);
          this.prTimer = setTimeout(() => (this.preventReveal = false), 800);
        };

        this.addEventListener('click', this._onClick);
        this.addEventListener('preventHeaderReveal', this._onPrevent);
        document.addEventListener('click', this._onDocClick);
        document.addEventListener('keydown', this._onKey);
        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._setHeight);
        if (this.desktopMq.addEventListener) this.desktopMq.addEventListener('change', this._onMq);
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this._setHeight);
          this.ro.observe(this);
        }

        this.initDropdowns();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.reveal());
        }

        this.setHeight();
        this.onScroll();
        if (this.dataset.editorDrawer === 'true') this.openDrawer(false);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
        this.removeEventListener('preventHeaderReveal', this._onPrevent);
        document.removeEventListener('click', this._onDocClick);
        document.removeEventListener('keydown', this._onKey);
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._setHeight);
        if (this.desktopMq.removeEventListener) this.desktopMq.removeEventListener('change', this._onMq);
        if (this.ro) this.ro.disconnect();
        if (this.unsubscribeCart) this.unsubscribeCart();
        if (this.open) this.unlock();
      }

      /* ---------- layout ---------- */
      setHeight() {
        const h = this.offsetHeight;
        const bar = this.querySelector('.ah-bar');
        if (bar) this.style.setProperty('--ah-bar-top', bar.offsetTop + 'px');
        if (this.section) this.section.style.setProperty('--ah-header-h', h + 'px');
        document.documentElement.style.setProperty('--header-height', h + 'px');
      }

      onScroll() {
        const y = Math.max(window.scrollY, 0);
        if (this.transparent) this.classList.toggle('is-transparent', y <= this.threshold);
        if (this.section) this.section.classList.toggle('ah-section--scrolled', y > 0);

        if (this.sticky === 'on-scroll-up' && !this.open) {
          const delta = y - this.lastY;
          if (y <= this.offsetHeight) this.reveal();
          else if (delta > 4) this.hide();
          else if (delta < -4 && !this.preventReveal) this.reveal();
        }
        this.lastY = y;
      }

      hide() {
        if (!this.section || this.section.classList.contains('ah-section--hidden')) return;
        this.section.classList.add('ah-section--hidden');
        this.closeDropdowns();
      }

      reveal() {
        if (this.section) this.section.classList.remove('ah-section--hidden');
      }

      /* ---------- desktop dropdowns ---------- */
      initDropdowns() {
        this.navItems = Array.from(this.querySelectorAll('.ah-nav__item--has-dropdown'));
        this.navItems.forEach((li) => {
          const link = li.querySelector('.ah-nav__link');
          li.addEventListener('mouseenter', () => { if (!this.clickMode) link.setAttribute('aria-expanded', 'true'); });
          li.addEventListener('mouseleave', () => { if (!this.clickMode) this.closeItem(li); });
          li.addEventListener('focusout', (e) => { if (!li.contains(e.relatedTarget)) this.closeItem(li); });
        });
      }

      openItem(li) {
        li.classList.add('is-open');
        const link = li.querySelector('.ah-nav__link');
        if (link) link.setAttribute('aria-expanded', 'true');
      }

      closeItem(li) {
        li.classList.remove('is-open');
        const link = li.querySelector('.ah-nav__link');
        if (link) link.setAttribute('aria-expanded', 'false');
      }

      closeDropdowns(except) {
        (this.navItems || []).forEach((li) => { if (li !== except) this.closeItem(li); });
      }

      /* ---------- events ---------- */
      onClick(e) {
        const navLink = e.target.closest('.ah-nav__item--has-dropdown > .ah-nav__link');
        if (navLink) {
          const li = navLink.parentElement;
          if ((this.clickMode || this.hoverNone.matches) && !li.classList.contains('is-open')) {
            e.preventDefault();
            this.closeDropdowns(li);
            this.openItem(li);
            return;
          }
        }

        const btn = e.target.closest('[data-ah-action]');
        if (!btn || !this.contains(btn)) return;

        switch (btn.dataset.ahAction) {
          case 'open-drawer': e.preventDefault(); this.openDrawer(); break;
          case 'close-drawer': this.closeDrawer(); break;
          case 'open-search': e.preventDefault(); this.openSearch(); break;
          case 'close-search': this.closeSearch(); break;
          case 'panel-open': this.openPanel(btn); break;
          case 'panel-back': this.closePanel(btn); break;
          case 'stories': this.triggerStories(btn, e); break;
        }
      }

      onDocClick(e) {
        if (!e.target.closest('.ah-nav')) this.closeDropdowns();
      }

      onKey(e) {
        if (e.key === 'Escape') {
          if (this.open === 'drawer') this.closeDrawer();
          else if (this.open === 'search') this.closeSearch();
          else this.closeDropdowns();
        }
        if (e.key === 'Tab' && this.open) this.trapFocus(e);
      }

      trapFocus(e) {
        const root = this.open === 'drawer'
          ? this.drawer && this.drawer.querySelector('.ah-drawer__panel')
          : this.search && this.search.querySelector('.ah-search__panel');
        if (!root) return;
        const items = Array.from(
          root.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), summary, [tabindex]:not([tabindex="-1"])')
        ).filter((el) => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }

      /* ---------- overlay state ---------- */
      lock(type) {
        this.open = type;
        this.classList.add('is-overlay-open');
        document.documentElement.classList.add('ah-lock');
        if (this.section) this.section.classList.add('ah-section--raised');
        this.reveal();
      }

      unlock() {
        this.open = null;
        this.classList.remove('is-overlay-open');
        document.documentElement.classList.remove('ah-lock');
        if (this.section) this.section.classList.remove('ah-section--raised');
      }

      setBurger(expanded) {
        this.querySelectorAll('[data-ah-action="open-drawer"]').forEach((b) => b.setAttribute('aria-expanded', String(expanded)));
      }

      /* ---------- drawer ---------- */
      openDrawer(focus = true) {
        if (!this.drawer) return;
        if (this.open === 'search') this.closeSearch(false);
        this.lastFocus = document.activeElement;
        clearTimeout(this.panelReset);
        this.drawer.classList.add('is-open');
        this.drawer.setAttribute('aria-hidden', 'false');
        this.setBurger(true);
        this.lock('drawer');
        if (focus) {
          setTimeout(() => {
            const close = this.drawer.querySelector('.ah-drawer__close');
            if (close) close.focus({ preventScroll: true });
          }, 60);
        }
      }

      closeDrawer(restore = true) {
        if (!this.drawer || !this.drawer.classList.contains('is-open')) return;
        this.drawer.classList.remove('is-open');
        this.drawer.setAttribute('aria-hidden', 'true');
        this.setBurger(false);
        this.unlock();
        this.panelReset = setTimeout(() => {
          this.drawer.querySelectorAll('.ah-panel.is-active').forEach((p) => p.classList.remove('is-active'));
          this.drawer.querySelectorAll('[data-ah-action="panel-open"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
        }, 450);
        if (restore && this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
      }

      openPanel(btn) {
        const panel = this.querySelector('[data-panel="' + btn.dataset.target + '"]');
        if (!panel) return;
        panel.scrollTop = 0;
        panel.classList.add('is-active');
        btn.setAttribute('aria-expanded', 'true');
        setTimeout(() => {
          const back = panel.querySelector('.ah-panel__back');
          if (back) back.focus({ preventScroll: true });
        }, 380);
      }

      closePanel(btn) {
        const panel = btn.closest('.ah-panel');
        if (!panel) return;
        panel.classList.remove('is-active');
        const opener = this.querySelector('[data-target="' + panel.dataset.panel + '"]');
        if (opener) {
          opener.setAttribute('aria-expanded', 'false');
          opener.focus({ preventScroll: true });
        }
      }

      /* ---------- search ---------- */
      openSearch() {
        if (!this.search) return;
        if (this.open === 'drawer') this.closeDrawer(false);
        this.lastFocus = document.activeElement;
        this.setHeight();
        this.search.classList.add('is-open');
        this.classList.add('is-search-open');
        this.search.setAttribute('aria-hidden', 'false');
        this.lock('search');
        const input = this.search.querySelector('input[type="search"]');
        if (input) input.focus({ preventScroll: true });
      }

      closeSearch(restore = true) {
        if (!this.search || !this.search.classList.contains('is-open')) return;
        this.search.classList.remove('is-open');
        this.classList.remove('is-search-open');
        this.search.setAttribute('aria-hidden', 'true');
        const ps = this.search.querySelector('predictive-search');
        if (ps && typeof ps.close === 'function') ps.close();
        const input = this.search.querySelector('input[type="search"]');
        if (input) input.blur();
        this.unlock();
        if (restore && this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
      }

      /* ---------- stories ---------- */
      triggerStories(btn, e) {
        const selector = btn.dataset.storiesSelector;
        if (selector) {
          const target = document.querySelector(selector);
          if (target) {
            e.preventDefault();
            target.click();
          }
        }
        document.dispatchEvent(new CustomEvent('ariiston:stories:open'));
      }
    }

    customElements.define('sticky-header', AriistonHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
